// tecnicoValidacion.js — reglas de validación compartidas entre
// TechnicianOrdersView.js (validateOrders(), lo que de verdad bloquea el
// cierre de ruta) y FinalizarVisitaModal.js (validate(), la misma regla
// aplicada al cerrar una visita individual, para que el técnico se entere
// de lo que falta mientras todavía está delante del cliente). Antes vivían
// como dos copias independientes — bastaba con arreglar una para que la
// otra se quedara desincronizada (pasó de verdad: "Sin fotos del equipo"
// solo aceptaba evidencia de StelOrder en una de las dos).

// "Imágenes del activo" no tiene por qué venir SOLO de la galería del activo
// en StelOrder (asset-images, subida desde la app de StelOrder aparte) — las
// fotos que el propio técnico sube en Finalizar visita (campo `fotos` de la
// orden) son evidencia igual de válida.
export function tieneFotosDelEquipo(order) {
  return !!order.assetHasImages || (Array.isArray(order.fotos) && order.fotos.length > 0);
}
